import apiClient from './config';
import { Client, Suscripcion, Plaza } from "../../types/index";
import type { ClaseCompletaResultado } from './plazaService';

export interface InscripcionFormData {
    client: Partial<Client>;
    subscription: Partial<Suscripcion>;
    plazas: Partial<Plaza>[];
    // D2 — si esta alta viene de alguien que vino a probar, el backend enlaza su
    // ficha de prueba con el cliente nuevo y le pasa su plaza en las clases
    // futuras. Se manda aqui, y no en una segunda llamada desde el navegador,
    // para que no se pierda si se cierra la pestana.
    prospectId?: string;
    // Por cada clase llena de sus plazas (id), si se le da una recuperación.
    compensaciones?: Record<string, boolean>;
    // Clases llenas que el operador tenía en el aviso: si al guardar hay alguna
    // más, el backend responde 409 CHOQUES_CAMBIADOS y no guarda.
    choquesVistos?: string[];
    // Casilla "Invitar al portal". Sin ella el backend usa el ajuste del centro.
    invitarPortal?: boolean;
}

export interface InscripcionResponse {
    message: string;
    client: Client;
    subscription: Suscripcion;
    plazas: Plaza[];
    sessionId: string; 
}

export interface Progress {
    _id: string;
    total: number;
    processed: number;
    status: 'processing' | 'completed' | 'error';
    type: string;
    error?: string;
    // Clases en las que no cupo por estar llenas, y si se le compensó cada una.
    clasesCompletas?: ClaseCompletaResultado[];
    // Inicio de su primera clase real: desde ahí se prorratea el primer mes.
    primeraClase?: string | null;
}

export const crearInscripcionCompleta = async (data: InscripcionFormData): Promise<InscripcionResponse> => {
    const response = await apiClient.post('/inscripciones', data);
    return response.data;
};

export const fetchInscripcionProgreso = async (sessionId: string): Promise<Progress> => {
    const response = await apiClient.get<Progress>(`/inscripciones/progreso/${sessionId}`);
    return response.data;
};